<template>
    <div class="page-container">
        <div class="page-content">
            <div class="left-side-container">
                <div class="page-header">
                    <h1>{{ $t('Бюджет') }}</h1>
                </div>

                <div class="empty-budgets-list" v-if="budgets.length === 0">
                    <p>
                        Use the budget to plan your income and expenses. You can specify the data for each month and select the main budget, based on it, your daily spending limit will be calculated.
                    </p>

                    <div class="empty-block">
                        <i class="icon icon-document"></i>

                        <p>You don't have a planned budget</p>
                    </div>
                </div>

                <div class="budgets-list" v-if="budgets.length != 0">
                    <router-link :to="`/budget/${budget.id}`" class="budget-item" v-for="budget in budgets" :key="budget.id">
                        <div class="budget-item-container">
                            <h4>
                                <span>{{ budget.name }}</span>
                                <span v-if="budget.is_main" class="is-main-budget">
                                    <i class="icon icon-check"></i>
                                </span>
                            </h4>
                            <div class="wallets">
                                <span class="wallet-name" v-for="account in budget.accounts" :key="account">{{ formatAccountName(account) }}</span>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
                
            <div class="right-side-container sticky">
                <RightSideUserControls />

                <NewBudgetForm />
            </div>
        </div>

        <MobilePlusBtn type="new-budget" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RightSideUserControls from "@/new/components/RightSideUserControls.vue";
import NewBudgetForm from "@/new/components/Budget/NewBudgetForm.vue";
import MobilePlusBtn from "@/new/components/MobilePlusBtn.vue";
import { EventBus } from '../../../../event-bus';

export default {
    name: "BudgetDashboard",

    components: {
        RightSideUserControls,
        NewBudgetForm,
        MobilePlusBtn
    },

    mounted() {
        this.loadAccounts();
        this.loadBudgets();
    },

    computed: {
        ...mapGetters(['budgets', 'accounts']),
    },

    methods: {
        ...mapActions(['loadBudgets', 'loadAccounts']),

        formatAccountName(id) {
            return this.accounts.find((account) => account.id === id).title;
        }
    }
}
</script>

<style scoped lang="scss">
.right-side-container {
    @media (max-width: 768px) {
        display: none;
    }
}

.page-container,
.page-content {
    height: 100%;
}

.left-side-container {
    height: 70%;

    @media (max-width: 768px) {
        height: 100%;
    }
}

.empty-budgets-list {
    height: 100%;

    p {
        font-size: 14px;
        font-family: "Proxima Nova Rg";
        color: rgba(#152640, .5);
        margin: 0;
    }
    
    .empty-block {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        .icon {
            width: 116px;
            height: 116px;
            margin-top: auto;
            background-color: rgba(#152640, .5);
            margin-bottom: 24px;
        }

        p {
            width: 100%;
            text-align: center;
            margin-bottom: auto;
            color: rgba(#152640, .5);
            font-size: 14px;
            font-family: "Proxima Nova Rg";
        }
    }
}

.budgets-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: -5px;

    @media (max-width: 768px) {
        width: 100%;
        padding-top: 24px;
        flex-wrap: wrap;
    }

    .budget-item {
        width: 45%;
        background: #fff;
        border-radius: 5px;
        margin: 5px 0px;
        padding: 16px;
        text-decoration: none;

        @media (max-width: 768px) {
            width: 100%;
            margin: 4px 24px;
        }

        &:nth-child(2n) {
            @media (min-width: 768px) {
                margin-right: 0;
            }
        }

        &:nth-child(2n - 1) {
            @media (min-width: 768px) {
                margin-left: 0;
            }
        }
        
        .budget-item-container {
            min-height: 108px;
            
            h4 {
                width: 100%;

                font-size: 18px;
                font-family: "Proxima Nova Lt";
                font-weight: 600;
                color: #152640;
                margin: 0;

                .is-main-budget {
                    float: right;

                    background: rgba(#359080, .2);
                    border-radius: 5px;
                    width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .icon {
                        background-color: #359080;
                    }
                }
            }

            .wallets {
                margin-top: 15px;
                display: flex;
                flex-wrap: wrap;

                .wallet-name {
                    color: #000;
                    font-size: 12px;
                    font-family: "Proxima Nova Lt";
                    font-weight: 600;
                    padding: 4px 15px;
                    border-radius: 15px;
                    background: rgba(#152640, .05);
                    margin-top: 5px;
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>